import React from "react";

const FeedbackIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1486_613)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 2C4.46957 2 3.96086 2.21071 3.58579 2.58579C3.21071 2.96086 3 3.46957 3 4V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H8V19H5V4H17V8H19V4C19 3.46957 18.7893 2.96086 18.4142 2.58579C18.0391 2.21071 17.5304 2 17 2H5ZM8 7C7.73478 7 7.48043 7.10536 7.29289 7.29289C7.10536 7.48043 7 7.73478 7 8C7 8.26522 7.10536 8.51957 7.29289 8.70711C7.48043 8.89464 7.73478 9 8 9H12C12.2652 9 12.5196 8.89464 12.7071 8.70711C12.8946 8.51957 13 8.26522 13 8C13 7.73478 12.8946 7.48043 12.7071 7.29289C12.5196 7.10536 12.2652 7 12 7H8ZM15.949 10.811C16.5132 10.256 17.2739 9.94648 18.0653 9.9498C18.8567 9.95311 19.6147 10.269 20.1743 10.8287C20.7338 11.3884 21.0496 12.1465 21.0527 12.9379C21.0558 13.7293 20.7461 14.4899 20.191 15.054L14.535 20.711C14.3475 20.8986 14.0932 21.0039 13.828 21.004H10.999C10.7338 21.004 10.4794 20.8986 10.2919 20.7111C10.1044 20.5236 9.999 20.2692 9.999 20.004V17.175C9.99906 16.9098 10.1045 16.6555 10.292 16.468L15.949 10.811ZM18.777 12.225C18.5895 12.0375 18.3352 11.9322 18.07 11.9322C17.8048 11.9322 17.5505 12.0375 17.363 12.225L18.777 13.64C18.87 13.5471 18.9437 13.4368 18.9941 13.3154C19.0444 13.194 19.0703 13.0639 19.0703 12.9325C19.0703 12.8011 19.0444 12.671 18.9941 12.5496C18.9437 12.4282 18.87 12.3179 18.777 12.225ZM17.363 15.054L15.949 13.64L11.999 17.59V19.004H13.413L17.363 15.054Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1486_613">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default FeedbackIcon;
